import { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/context/AuthContext';
import Signin from '@/components/auth/Signin';
import Search from './Search';
import useCustomSWR from '@/hook/useCustomSWR';
import dynamic from 'next/dynamic';
const Cart = dynamic(() => import('@/components/cart'));
const Wishlist = dynamic(() => import('@/components/wishlist'));
import { usePathname } from 'next/navigation';
import SignButton from './SignButton';
import { FaSearch } from 'react-icons/fa';
function Sidebar() {
  const pathname = usePathname();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchPopupRef = useRef(null)
  const isBuyPage =
    pathname?.startsWith('/product') && pathname.includes('/buy/');

  const { isSignInOpen, setIsSignInOpen } = useAuth();
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [userName, setUserName] = useState('');

  const [showMenu, setShowMenu] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showBrands, setShowBrands] = useState(false);
  const [showCountries, setShowCountries] = useState(false);
  const [showAwards, setShowAwards] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const router = useRouter();

  useEffect(() => {
  const handleOutsideClick = (e) => {
    if (isSearchOpen && searchPopupRef.current && !searchPopupRef.current.contains(e.target)) {
      setIsSearchOpen(false)
    }
  }

  document.addEventListener('mousedown', handleOutsideClick)
  document.addEventListener('touchstart', handleOutsideClick)

  return () => {
    document.removeEventListener('mousedown', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
}, [isSearchOpen])


  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let userName = localStorage.getItem('phone');
    setUserName(userName);
  }, [isSignInOpen]);

  useEffect(() => {
    let userName = localStorage.getItem('user_name');
    setUserName(userName);
  }, []);

  const { data: menu, error } = useCustomSWR(
    `/v1/categories/get/menu?page=1&limit=500`,
    true
  );

  const toggleMenu = () => {
    setShowMenu(!showMenu);
    setShowCategories(false);
    setShowBrands(false);
    setShowCountries(false);
    setShowAwards(false);
    setSelectedCategory(null);
  };

  const toggleMenuClose = () => {
    setShowMenu(false);
    setShowCategories(false);
    setShowBrands(false);
    setShowCountries(false);
    setShowAwards(false);
    setSelectedCategory(null);
  };

  const toggleCategories = () => {
    setShowCategories(!showCategories);
    setShowMenu(false);
    setShowBrands(false);
    setShowCountries(false);
    setShowAwards(false);
  };

  const toggleCategory = (categoryId) => {
    setSelectedCategory(selectedCategory === categoryId ? null : categoryId);
  };

  const toggleBrands = () => {
    setShowBrands(!showBrands);
    setShowMenu(false);
    setShowCategories(false);
    setShowCountries(false);
    setShowAwards(false);
  };

  const toggleCountries = () => {
    setShowCountries(!showCountries);
    setShowMenu(false);
    setShowCategories(false);
    setShowBrands(false);
    setShowAwards(false);
  };

  const toggleAwards = () => {
    setShowAwards(!showAwards);
    setShowMenu(false);
    setShowCategories(false);
    setShowBrands(false);
    setShowCountries(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickInsideMenu = event.target.closest('.sidebar-menu');
      const isClickInsideMenuItem = event.target.closest('.sidebar-menu-item');

      if (!isClickInsideMenu && !isClickInsideMenuItem) {
        setShowMenu(false);
        setShowCategories(false);
        setShowBrands(false);
        setShowCountries(false);
        setShowAwards(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const goBack = () => {
    if (showCategories || showBrands || showCountries || showAwards) {
      setShowCategories(false);
      setShowBrands(false);
      setShowCountries(false);
      setShowAwards(false);
      setShowMenu(true); // Open the main menu
    }
  };

  const handleButtonClick = () => {
    router.push('/product');
    toggleMenuClose();
  };

  const getLink = (type, id, name) => {
    if (type === 'category') {
      return `${id}`;
    }
    if (type === 'brand') {
      return `/brand/${name
        ?.toLowerCase()
        ?.replace(' ', '-')}/home?brand_id=${id}`;
    }
    if (type === 'award') {
      return `/product?name=award&id=${id}`;
    }
    if (type === 'country') {
      return `/product?name=country&id=${id}`;
    }
  };

  return (
    <div className='flex items-center justify-between gap-2 bg-white p-2 lg:hidden'>
      <div className='flex items-center space-x-2'>
        <button onClick={toggleMenu} className='block p-2 text-black'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='1.5'
            stroke='currentColor'
            className='h-5 w-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5'
            />
          </svg>
        </button>
        <Link className='block' href='/'>
          <img
            className='h-7 w-7 sm:h-10 sm:w-10'
            src='https://res.cloudinary.com/genx21/image/upload/v1733467899/images/ymrlt4hltxftbonhpsd3.png'
            alt='21genx logo'
          />
        </Link>
      </div>
      <div className='flex items-center space-x-2'>
        <div className='relative mt-1'>
          <button 
          onClick={() => setIsSearchOpen(true)}>
            <svg
              className='h-6 w-4 mt-2'
              aria-hidden='true'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 20 20'
            >
              <path
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z'
              />
            </svg>
          </button>

          {isSearchOpen && (
            <div className='fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50'>
              <div
               ref={searchPopupRef}
               className='mx-auto mt-4 w-full max-w-md rounded-md bg-white p-2 shadow-lg'>
                <Search
                  // pathname={pathname}
                  // isBelowHero={false}
                  isBuyPage={isBuyPage}
                />
              </div>
            </div>
          )}
        </div>
        <div
          className={`${isBuyPage ? 'mx-2 mt-1 flex items-center justify-center space-x-2' : 'hidden'} `}
        >
          <Link href={`/user/wishlist`}>
            <Wishlist />
          </Link>
          <Cart />
        </div>
        <div>
          <SignButton />
        </div>
      </div>

      {showMenu && (
        <div className='sidebar-menu fixed left-0 top-0 min-h-screen w-48 bg-white px-2 py-4 shadow-lg'>
          <button onClick={toggleMenu} className='-mt-2 block p-2 text-black'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='h-5 w-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5'
              />
            </svg>
          </button>
          <ul className='pb-4'>
            <div>
              <Signin
                isSignInOpen={isSignInOpen}
                onClose={() => setIsSignInOpen(false)}
              />
            </div>
            <div>
              <button
                onClick={() => handleButtonClick('All')}
                className='sidebar-menu-item flex w-full items-center justify-between py-2 pl-4 pr-6 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none'
              >
                All
              </button>
            </div>
            <div>
              <button
                onClick={toggleCategories}
                className='flex w-full items-center justify-between py-2 pl-4 pr-6 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none'
              >
                Categories
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='h-4 w-4'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m8.25 4.5 7.5 7.5-7.5 7.5'
                  />
                </svg>
              </button>
            </div>
            <div>
              <button
                onClick={toggleBrands}
                className='flex w-full items-center justify-between py-2 pl-4 pr-6 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none'
              >
                Brands
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='h-4 w-4'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m8.25 4.5 7.5 7.5-7.5 7.5'
                  />
                </svg>
              </button>
            </div>
            <div>
              <button
                onClick={toggleCountries}
                className='flex w-full items-center justify-between py-2 pl-4 pr-6 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none'
              >
                Countries
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='h-4 w-4'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m8.25 4.5 7.5 7.5-7.5 7.5'
                  />
                </svg>
              </button>
            </div>
            <div>
              <button
                onClick={toggleAwards}
                className='flex w-full items-center justify-between py-2 pl-4 pr-6 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none'
              >
                Awards
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='h-4 w-4'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m8.25 4.5 7.5 7.5-7.5 7.5'
                  />
                </svg>
              </button>
            </div>
            <div className='flex flex-col'>
              <a
                className='py-2 pl-4 pr-6'
                href='/blog'
                target='_blank'
                rel='noreferrer'
              >
                Blog
              </a>
              <a
                className='py-2 pl-4 pr-6'
                href='/contact'
                target='_blank'
                rel='noreferrer'
              >
                Contact Us
              </a>
              <a
                className='py-2 pl-4 pr-6'
                href='/about'
                target='_blank'
                rel='noreferrer'
              >
                About Us
              </a>
            </div>
          </ul>
        </div>
      )}
      {showCategories && (
        <div className='sidebar-menu fixed left-0 top-0 z-0 min-h-screen w-48 bg-white px-2 py-4 shadow-lg transition-transform duration-300 ease-in-out'>
          <button onClick={goBack} className='-mt-2 block p-2 text-black'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </button>
          <ul className='pb-4'>
            {menu?.parentCategories?.map((parentCategory) => (
              <li key={parentCategory._id}>
                <button
                  className={`flex w-full items-center justify-between whitespace-nowrap py-2 pl-4 pr-1 text-gray-900 transition-colors duration-300 ease-in-out focus:outline-none ${
                    selectedCategory === parentCategory._id
                      ? 'bg-gray-900 text-white'
                      : ''
                  }`}
                  onClick={() => toggleCategory(parentCategory._id)}
                >
                  {parentCategory.category_name}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    className={`h-4 w-4 ${
                      selectedCategory === parentCategory._id
                        ? 'rotate-180 transform'
                        : ''
                    }`}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M19 9l-7 7-7-7'
                    />
                  </svg>
                </button>
                {selectedCategory === parentCategory._id && (
                  <ul className='pl-4'>
                    {parentCategory.subCategories.map((subCategory) => (
                      <li key={subCategory._id}>
                        {subCategory.childCategories &&
                          subCategory.childCategories.length > 0 && (
                            <ul className='ml-1 mt-2'>
                              {subCategory.childCategories.map(
                                (childCategory, childIndex) => (
                                  <li
                                    key={childIndex}
                                    className='py-1 text-gray-600'
                                  >
                                    <a
                                      href={getLink(
                                        'category',
                                        childCategory.childCategoriesPath
                                      )}
                                    >
                                      {childCategory.category_name}
                                    </a>
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      {showBrands && (
        <div className='sidebar-menu min fixed left-0 top-0 min-h-screen w-48 bg-white px-2 py-4 shadow-lg transition-transform duration-300 ease-in-out'>
          <button onClick={goBack} className='-mt-2 block p-2 text-black'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </button>
          <ul className='pb-4'>
            <Link href='/brand'>
              <span className='mr-2 inline-block px-2 py-1.5 text-sm capitalize text-gray-700 hover:font-semibold'>
                ALL
              </span>
            </Link>
            {menu?.brandList?.map((brand) => (
              <li
                key={brand._id}
                className='cursor-pointer p-2 text-black hover:bg-gray-200 hover:text-black'
              >
                <a href={`/brand/${brand.slug}`}>{brand.brand_name}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
      {showCountries && (
        <div className='sidebar-menu min fixed left-0 top-0 min-h-screen w-48 bg-white px-2 py-4 shadow-lg transition-transform duration-300 ease-in-out'>
          <button onClick={goBack} className='-mt-2 block p-2 text-black'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </button>
          <ul className='pb-4'>
            {menu?.country?.map((country) => (
              <li
                key={country._id}
                className='cursor-pointer p-2 text-black hover:bg-gray-200 hover:text-black'
              >
                <img
                  src={country.image}
                  alt={country.country_name}
                  className='mr-2 inline h-4 w-4 rounded-full'
                />
                <a href={`/countries/${country.slug}`}>
                  {country.country_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      {showAwards && (
        <div className='sidebar-menu min fixed left-0 top-0 h-full min-h-screen w-48 overflow-y-scroll bg-white px-2 py-4 shadow-lg transition-transform duration-300 ease-in-out'>
          <button onClick={goBack} className='-mt-2 block p-2 text-black'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </button>
          <ul className='pb-4'>
            {menu?.awards?.map((award) => (
              <li
                key={award._id}
                className='cursor-pointer p-2 text-black hover:bg-gray-200 hover:text-black'
              >
                <a href={`/awards/${award.slug}`}>{award.award_name}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
